// @flow
import AsyncStorage from '@react-native-community/async-storage'
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
  useCallback,
} from 'react'
import CryptoJS from 'crypto-js'
import sha256 from 'crypto-js/sha256'

import { Astrolabe } from '../../../api'
import { KEY_LOCAL_TAS } from '../constants'
import { useAuthContext } from '../../signIn/context'
import { prefix } from '../../../constants'
import { secret } from '../../../api'
import { suffix } from '../../config'

const AstrolabeContext = createContext()

export const useAstrolabe = () => useContext(AstrolabeContext)
type Props = {
  children: any,
}
const key = `${prefix}.${secret}$${suffix}`
export const AstrolabeProvider = ({ children }: Props) => {
  // console.log('Localization: ', Localization)
  const { state } = useAuthContext()
  const [draftTA, setDraftTA] = useState()
  const [ta, setTA] = useState()
  const [astrolabe, setAstrolabe] = useState()
  const [taList, setTAList] = useState()

  const getCachedTAList = useCallback(async () => {
    const cached = await AsyncStorage.getItem(`${KEY_LOCAL_TAS}_${sha256(state.signInStatus)}`)
    try {
      let taList
      if (cached) {
        const bytes = CryptoJS.AES.decrypt(cached, key)
        const originalText = bytes.toString(CryptoJS.enc.Utf8)
        taList = JSON.parse(originalText)
      }
      setTAList(taList || [])
    } catch (err) {
      console.error('invalid json string: ', cached)
    }
  }, [state])
  const actions = useMemo(
    () => ({
      setDraftTA,
      setSelectedTA: ta => {
        setTA(ta)
        setAstrolabe(new Astrolabe(ta.lunarDate, ta.isMale))
      },
      setTAList,
      getCachedTAList,
    }),
    [getCachedTAList],
  )

  useEffect(() => {
    if (taList) {
      AsyncStorage.setItem(`${KEY_LOCAL_TAS}_${sha256(state.signInStatus)}`, CryptoJS.AES.encrypt(JSON.stringify(taList), key).toString())
    }
  }, [taList])

  return (
    <AstrolabeContext.Provider
      value={{
        draftTA,
        ta,
        astrolabe,
        taList,
        ...actions,
      }}>
      {children}
    </AstrolabeContext.Provider>
  )
}
